import React, { createContext, useContext } from 'react';

import type { RovoConfigProviderProps } from '../shared-types/rovoConfigTypes.tsx';

const RovoConfigProviderContext = createContext<RovoConfigProviderProps | null>(null);

export const useRovoConfigProviderProps = (): RovoConfigProviderProps => {
	const context = useContext(RovoConfigProviderContext);
	if (!context) {
		throw new Error(
			'useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider',
		);
	}
	return context;
};

export const RovoConfigProviderContextProvider = ({
	children,
	value,
}: {
	children: React.ReactNode;
	value: RovoConfigProviderProps;
}) => {
	return (
		<RovoConfigProviderContext.Provider value={value}>
			{children}
		</RovoConfigProviderContext.Provider>
	);
};
